export default function EFRefrigerator(props: any) {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Refrigerator_icon">
                    <rect id="矩形" x="0" y="0" width="30" height="30"></rect>
                    <g id="编组-67" transform="translate(6.000000, 1.000000)" stroke={props.color || '#FFFFFF'}>
                        <path
                            d="M16.4798041,28 L1.52019583,28 C1.10223918,28 0.723810208,27.8342996 0.448412412,27.565355 C0.171718626,27.2951359 0,26.9197607 0,26.5048723 L0,1.495765 C0,1.09426011 0.160702714,0.729081872 0.42249262,0.460774645 C0.699186405,0.177171993 1.08863129,0 1.52019583,0 L16.4798041,0 C16.9385844,0 17.3500611,0.200115129 17.628699,0.516857865 C17.8600331,0.779429309 18,1.12102711 18,1.495765 L18,26.5048723 C18,26.947165 17.8043055,27.344846 17.494564,27.6182517 C17.2249982,27.8553308 16.869897,28 16.4798041,28 Z"
                            id="Stroke-51"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <line x1="3.5" y1="5" x2="3.5" y2="7" id="Stroke-53" strokeWidth="1.09467623" strokeLinecap="round" strokeLinejoin="round"></line>
                        <line x1="3.5" y1="15" x2="3.5" y2="18" id="Stroke-55" strokeWidth="1.09467623" strokeLinecap="round" strokeLinejoin="round"></line>
                        <line x1="0" y1="11.5" x2="18" y2="11.5" id="路径-4"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
